import { FeatureFlag, isFeatureEnabled } from 'Utils/FeatureFlags';

export const isRepertoireCreateAvailable = () =>
  isFeatureEnabled(FeatureFlag.USE_REPERTOIRE_CREATE);
